export default class ProfileHelper {
    constructor(configuration, axios) {
        this.configuration = configuration;
        this.axios = axios;
        this.profile = {};
    }

    getCode() {
        window.location.href = this.configuration.LOGIN_URL;
    }
}